import { Link } from 'react-router-dom';

const SportsLayout = ({ parentMenuItem, menuItems }) => {
	return (
		<>
			{menuItems
				.filter(x => x.pid === parentMenuItem.id)
				.map((item, index) => (
					<div key={index} className="column sports-layout">
						<div className="image-menu-item">
							<Link to={item.nu}>
								<img src={item.img1} alt={item.tl} />
								<b>{item.tl}</b>
							</Link>
						</div>
					</div>
				))}
		</>
	);
};

export default SportsLayout;
